<div class="home">

    <!-- ============ HERO ============ -->
    <section class="hero">
        <div class="hero__stage" [style.transform]="'translate3d(0,' + heroScrollProgress * 60 + 'px,0)'">
            <div class="hero__slide"
                 *ngFor="let slide of heroSlides; let i = index"
                 [class.hero__slide--active]="i === activeSlide">
                <img [src]="slide.image" [alt]="slide.alt" loading="eager">
            </div>
            <span class="hero__scrim"></span>
            <span class="hero__grain"></span>
        </div>

        <div class="hero__inner rs-container"
             [style.opacity]="1 - heroScrollProgress * 0.9">
            <span class="hero__status" [class.hero__status--open]="openingState.open">
                <span class="hero__status__dot"></span>{{openingState.label}}
            </span>

            <h1 class="hero__title">
                <span class="hero__title__line">Fleisch mit</span>
                <span class="hero__title__line hero__title__line--accent">Herkunft.</span>
                <span class="hero__title__line">Handwerk mit Herz.</span>
            </h1>

            <p class="hero__text">
                Metzgerei, Marktstub'n und Feinkost in St. Johann im Pongau.
                Aus eigener Schlachtung, von Höfen aus der Nachbarschaft – in&nbsp;Familienhand.
            </p>

            <div class="hero__actions">
                <a class="rs-btn rs-btn--solid-light" routerLink="/speiseplan">
                    Speiseplan &amp; Wochenkarte
                </a>
                <a class="rs-btn rs-btn--light"
                   href="https://bestellen.marktstubn.com/"
                   target="_blank"
                   rel="noopener">Vorbestellen</a>
            </div>

            <div class="hero__dots" role="tablist" aria-label="Bildwechsel">
                <button class="hero__dot"
                        *ngFor="let slide of heroSlides; let i = index"
                        [class.hero__dot--active]="i === activeSlide"
                        (click)="goToSlide(i)"
                        [attr.aria-label]="'Bild ' + (i + 1) + ' anzeigen'"></button>
            </div>
        </div>

        <a class="hero__scroll" href="#heute" aria-label="Weiter scrollen">
            <span class="hero__scroll__label">Entdecken</span>
            <span class="hero__scroll__line"></span>
        </a>
    </section>

    <!-- ============ MARQUEE ============ -->
    <div class="marquee" aria-hidden="true">
        <div class="marquee__track">
            <ng-container *ngFor="let repeat of [0, 1]">
                <span>Eigene Schlachtung</span><span class="marquee__dot">✦</span>
                <span>Pongauer Wild</span><span class="marquee__dot">✦</span>
                <span>Hausgemachte Wurst</span><span class="marquee__dot">✦</span>
                <span>Täglich frischer Mittagstisch</span><span class="marquee__dot">✦</span>
                <span>AMA Lukullus</span><span class="marquee__dot">✦</span>
                <span>Feinkost &amp; Jause</span><span class="marquee__dot">✦</span>
                <span>Frühstück &amp; Kaffee</span><span class="marquee__dot">✦</span>
            </ng-container>
        </div>
    </div>

    <!-- ============ HEUTE / SPEISEPLAN TEASER ============ -->
    <section class="today rs-section" id="heute">
        <div class="rs-container">
            <div class="today__head" [rsReveal]="0">
                <div>
                    <p class="rs-eyebrow">Mittagstisch</p>
                    <h2 class="today__title">
                        {{isToday ? 'Heute in der Marktstub\'n' : 'Als Nächstes in der Marktstub\'n'}}
                    </h2>
                </div>
                <a class="today__link" routerLink="/speiseplan">
                    Zur ganzen Woche
                    <span class="today__link__arrow" aria-hidden="true">→</span>
                </a>
            </div>

            <div class="today__grid" *ngIf="todayMenus.length; else noMenu">
                <article class="today__card"
                         *ngFor="let menu of todayMenus; let i = index"
                         [rsReveal]="i * 120">
                    <div class="today__card__top">
                        <span class="today__card__label">Menü {{i + 1}}</span>
                        <span class="today__card__day">{{todayWeekday}}</span>
                    </div>
                    <p class="today__card__starter" *ngIf="menu.vorspeise">{{menu.vorspeise}}</p>
                    <p class="today__card__main">{{menu.hauptspeise}}</p>
                    <p class="today__card__price" *ngIf="menu.preis">€ {{menu.preis}}</p>
                </article>

                <article class="today__card today__card--cta" [rsReveal]="240">
                    <p class="today__card__label">Vorbestellen</p>
                    <p class="today__card__main">Bis 11:00 Uhr bestellen, Abholzeit wählen, mitnehmen.</p>
                    <a class="rs-btn rs-btn--solid-light"
                       href="https://bestellen.marktstubn.com/"
                       target="_blank"
                       rel="noopener">Jetzt vorbestellen</a>
                </article>
            </div>

            <ng-template #noMenu>
                <div class="today__empty" [rsReveal]="0">
                    <p class="today__card__main">
                        {{menusLoaded ? 'Aktuell ist kein Tagesmenü hinterlegt.' : 'Menüs werden geladen …'}}
                    </p>
                    <a class="rs-btn rs-btn--ghost" routerLink="/speiseplan">Zum Speiseplan</a>
                </div>
            </ng-template>

            <div class="weekly" *ngIf="weeklyMenus.length">
                <div class="weekly__head" [rsReveal]="0">
                    <p class="rs-eyebrow">Die ganze Woche</p>
                    <h3 class="weekly__title">Wochenkarte</h3>
                </div>
                <div class="weekly__scroller">
                    <article class="weekly__card" *ngFor="let weeklyMenu of weeklyMenus">
                        <p class="weekly__card__main">{{weeklyMenu.menu.hauptspeise}}</p>
                        <p class="weekly__card__price" *ngIf="weeklyMenu.menu.preis">
                            € {{weeklyMenu.menu.preis}}
                        </p>
                    </article>
                </div>
            </div>
        </div>
    </section>

    <app-family-story></app-family-story>

    <!-- ============ HIGHLIGHTS / BENTO ============ -->
    <section class="bento rs-section">
        <div class="rs-container">
            <div class="bento__head" [rsReveal]="0">
                <p class="rs-eyebrow rs-eyebrow--center">Was uns ausmacht</p>
                <h2 class="title">Ein Haus, vier gute Gründe zu bleiben</h2>
            </div>

            <div class="bento__grid">
                <article class="bento__card"
                         *ngFor="let highlight of highlights; let i = index"
                         [rsReveal]="i * 90">
                    <div class="bento__card__media">
                        <img [src]="highlight.image" [alt]="highlight.title" loading="lazy">
                    </div>
                    <div class="bento__card__body">
                        <p class="bento__card__eyebrow">{{highlight.eyebrow}}</p>
                        <h3 class="bento__card__title">{{highlight.title}}</h3>
                        <p class="bento__card__text">{{highlight.text}}</p>
                        <a class="bento__card__link" *ngIf="highlight.link" [routerLink]="highlight.link">
                            Mehr dazu
                            <span aria-hidden="true">→</span>
                        </a>
                    </div>
                </article>
            </div>
        </div>
    </section>

    <!-- ============ EINBLICK / VIDEOS ============ -->
    <section class="films">
        <div class="rs-container">
            <div class="films__head" [rsReveal]="0">
                <p class="rs-eyebrow rs-eyebrow--center">Einblick</p>
                <h2 class="films__title">Ein Blick über die Schulter</h2>
                <p class="films__text">
                    Hinter die Theke geschaut – und zu einer Auszeichnung, auf die wir stolz sind.
                </p>
            </div>

            <div class="films__grid">
                <figure class="films__item" [rsReveal]="0">
                    <video class="films__video"
                           controls
                           preload="metadata"
                           playsinline
                           poster="assets/video/home-1-poster.jpg">
                        <source src="assets/video/home-1.mp4" type="video/mp4">
                    </video>
                    <figcaption>Unterwegs in unserer Metzgerei</figcaption>
                </figure>
                <figure class="films__item" [rsReveal]="120">
                    <video class="films__video" controls preload="metadata" playsinline>
                        <source src="assets/video/home-2.mp4" type="video/mp4">
                    </video>
                    <figcaption>AMA Lukullus Verleihung 2019 – bereits zum zweiten Mal ausgezeichnet</figcaption>
                </figure>
            </div>
        </div>
    </section>

    <!-- ============ GALERIE ============ -->
    <section class="gallery rs-section">
        <div class="rs-container">
            <div class="gallery__head" [rsReveal]="0">
                <p class="rs-eyebrow rs-eyebrow--center">Bei uns</p>
                <h2 class="title">Metzgerei, Stub'n &amp; Sonnenterrasse</h2>
            </div>
        </div>

        <div class="gallery__grid rs-container">
            <button class="gallery__item"
                    *ngFor="let image of galleryImages; let i = index"
                    [rsReveal]="(i % 4) * 80"
                    (click)="openLightbox(i)"
                    [attr.aria-label]="image.alt">
                <img [src]="image.src" [alt]="image.alt" loading="lazy">
                <span class="gallery__item__zoom" aria-hidden="true">+</span>
            </button>
        </div>
    </section>

    <!-- ============ AUSZEICHNUNGEN ============ -->
    <section class="awards">
        <div class="rs-container awards__inner">
            <div class="awards__body" [rsReveal]="0">
                <p class="rs-eyebrow">Auszeichnungen</p>
                <h2 class="awards__title">Ausgezeichnet für Herkunft und Handwerk</h2>
                <p class="awards__text">
                    Zweifach mit dem AMA Lukullus prämiert, empfohlen vom Restaurant Guru und zertifizierter
                    Mitgliedsbetrieb der Genussregion Pongauer Wild.
                </p>
                <div class="awards__badges">
                    <img src="assets/img/auszeichnungen/ama-siegel.png" alt="AMA Gütesiegel" loading="lazy">
                </div>
            </div>

            <div class="awards__ribbon" [rsReveal]="120">
                <div id="circle-r-ribbon" (click)="openRestaurantGuru($event)">
                    <div class="r-ribbon_ahead ">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="160px"
                             height="160px" viewBox="0 0 160 160">
                            <defs>
                                <path id="heading-arc" d="M 30 80 a 50 50 0 1 1 100 0"></path>
                            </defs>
                            <text class="r-ribbon_ahead-heading " fill="#000" text-anchor="middle">
                                <textPath startOffset="50%" xlink:href="#heading-arc">Empfohlen</textPath>
                            </text>
                        </svg>
                    </div>
                    <p class="r-ribbon_year">2024</p>
                    <a href="https://restaurantguru.com/Metzgerei-Scharfetter-Saint-Johann-im-Pongau"
                       class="r-ribbon_title f8" target="_blank">Metzgerei Rettensteiner-Scharfetter</a>
                    <div class="r-ribbon_ahead r-ribbon_ahead-bottom">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="120px"
                             height="120px" viewBox="0 0 120 120">
                            <defs>
                                <path id="subheading-arc" d="M 12 60 a 48 48 0 0 0 96 0"></path>
                            </defs>
                            <text class="r-ribbon_ahead-subh" fill="#000" text-anchor="middle">
                                <textPath startOffset="50%" xlink:href="#subheading-arc">
                                    <a href="https://restaurantguru.com" target="_blank">Restaurant Guru</a>
                                </textPath>
                            </text>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- ============ NEWS ============ -->
    <section class="news">
        <app-bdm-news></app-bdm-news>
    </section>

    <!-- ============ BESUCH / KONTAKT ============ -->
    <section class="visit">
        <div class="rs-container visit__inner">
            <div class="visit__body" [rsReveal]="0">
                <p class="rs-eyebrow">Vorbeikommen</p>
                <h2 class="visit__title">Hans Kappacherstraße 9<br>5600 St. Johann im Pongau</h2>

                <dl class="visit__hours">
                    <div>
                        <dt>Montag – Freitag</dt>
                        <dd>07:30 – 18:00 Uhr</dd>
                    </div>
                    <div>
                        <dt>Samstag</dt>
                        <dd>07:00 – 12:00 Uhr</dd>
                    </div>
                    <div>
                        <dt>Sonntag</dt>
                        <dd>geschlossen</dd>
                    </div>
                </dl>

                <div class="visit__actions">
                    <a class="rs-btn rs-btn--solid-light"
                       href="https://www.openstreetmap.org/?mlat=47.3469044&mlon=13.2023823#map=18/47.34690/13.20238"
                       target="_blank"
                       rel="noopener">Route planen</a>
                    <a class="rs-btn rs-btn--light" href="tel:+43641220245">+43 6412 20 245</a>
                </div>
            </div>

            <div class="visit__map" [rsReveal]="120">
                <iframe title="Standort der Metzgerei Rettensteiner-Scharfetter"
                        src="https://www.openstreetmap.org/export/embed.html?bbox=13.19438%2C47.34190%2C13.21038%2C47.35190&amp;layer=mapnik&amp;marker=47.3469044%2C13.2023823"
                        loading="lazy"
                        referrerpolicy="no-referrer"></iframe>
            </div>
        </div>
    </section>

    <!-- ============ LIGHTBOX ============ -->
    <div class="lightbox" *ngIf="lightboxImage as image" (click)="closeLightbox()">
        <button class="lightbox__close" (click)="closeLightbox()" aria-label="Schließen">×</button>
        <button class="lightbox__nav lightbox__nav--prev"
                (click)="stepLightbox(-1, $event)"
                aria-label="Vorheriges Bild">‹
        </button>
        <img class="lightbox__image"
             [src]="image.src"
             [alt]="image.alt"
             (click)="$event.stopPropagation()">
        <button class="lightbox__nav lightbox__nav--next"
                (click)="stepLightbox(1, $event)"
                aria-label="Nächstes Bild">›
        </button>
    </div>
</div>
